import BlogImage from 'static/img/landing/blog/CECA_LandingHeader_Section01.jpg';
import BlogSectionWrapper from 'components/landing/blog-section/components/blog-section-wrapper';
import Image from 'core/image';
import styles from 'styles/LandingBlogSection.module.scss';
import useGetSeoTextByIndex from 'hooks/useGetSeoTextByIndex';
import useRichTranslation from 'hooks/useRichTranslation';

const BlogSectionOne = () => {
    const t = useRichTranslation('blog-section-one');
    const { seoText, verification } =
        useGetSeoTextByIndex('blog_section_01');
    const altText = t('alt-banner');

    if (!verification) {
        return null;
    }

    return (
        <BlogSectionWrapper>
            <div>
                <h2 className={styles.section__title}>
                    {t('section-title')}
                </h2>
            </div>
            <div className={styles.section__image_wrapper}>
                <Image alt={altText} src={BlogImage} />
            </div>
            <div className={styles.content_text}>
                <p>
                    {seoText.paragraph1.sentence1}
                    {seoText.paragraph1.sentence2}
                    {seoText.paragraph1.sentence3}
                </p>
            </div>
            <div className={styles.content_text}>
                <p>
                    <strong>{seoText.paragraph2.sentence1}</strong>
                </p>
            </div>
            <div
                className={styles.content_text}
                dangerouslySetInnerHTML={{
                    __html: seoText.paragraph3.sentence1
                }}
            />
            <div className={styles.content_text}>
                <p>
                    {seoText.paragraph4.sentence1}
                    {seoText.paragraph4.sentence2}
                    {seoText.paragraph4.sentence3}
                    {seoText.paragraph4.sentence4}
                </p>
            </div>
        </BlogSectionWrapper>
    );
};

export default BlogSectionOne;
